import { render, staticRenderFns } from "./orderWxshenpi.vue?vue&type=template&id=c43ca00e&scoped=true"
import script from "./orderWxshenpi.vue?vue&type=script&lang=js"
export * from "./orderWxshenpi.vue?vue&type=script&lang=js"
import style0 from "./orderWxshenpi.vue?vue&type=style&index=0&id=c43ca00e&prod&scoped=true&lang=css"
import style1 from "./orderWxshenpi.vue?vue&type=style&index=1&id=c43ca00e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43ca00e",
  null
  
)

export default component.exports